const importAws = () => import('aws-sdk');
const config = {
  s3UploadUser: process.env.VUE_APP_S3_UPLOAD_USER || 'AKIAVO2W7E7SS542VPGB',
  s3UploadUserSecret: process.env.VUE_APP_S3_UPLOAD_USER_SECRET || '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',
  bucket: process.env.VUE_APP_S3_BUCKET || 'statics.tracking.faceclub.ch'
};

let s3 = null;
const awsPromise = importAws()
  .then(aws => {
    aws.config.update({
      region: 'eu-central-1',
      credentials: new aws.Credentials({
        accessKeyId: config.s3UploadUser,
        secretAccessKey: config.s3UploadUserSecret
      })
    });
    s3 = new aws.S3();
  })

export const uploadFile = (key, file) =>
  awsPromise.then(() =>
    s3.upload({
      Bucket: config.bucket,
      Body: file,
      ACL: 'public-read',
      ContentType: file.type,
      Key: key
    }));
